export default {
  navbar: {
    Home: "首页",
    Dashboard: "看板",
    My: "我的",
    Support: "支持",
    Projects: "项目",
    ProjectCount: "项目数量",
    Admin: "管理",
    Library: "资料库",
    ProjectList: "项目列表",
    Profile: "概况",
    SiteObservation: "现场观察",
    GenerateReport: "生成报告",
    BaselineConfig: "基线配置",
    MonthlyBaseline: "月度基线",
    EquipmentSpecs: "设备规格",
    BaselinePreview: "基线预览",
    Analysis: "数据分析",
    Menu: "菜单",
    Objective: "目标",

    RetrofitSolution: "改造方案",
    ExistingEqptSpecs: "现有设备规格",

    Baseline: "基线",
    Proposed: "提案",
    SetupOperatingCondition: "设置运行工况",
    DefineNewEquipment: "定义新设备"
  },

  ctrl: {
    Login: "登录",
    Logout: "退出登录",
    Register: "注册",
    ModifyPassword: "修改密码",
    Language: "语言",
    UserGuide: "用户指南",
    UserSetting: "用户设置",
    Delete: "删除",
    Cancel: "取消",
    Edit: "编辑",
    Copy: "复制",
    Paste: "粘贴",
    Proceed: "继续",
    Save: "保存",
    Back: "上一页",
    Next: "下一页",
    Confirm: "确认",
    Close: "关闭",
    Exit: "退出",
    All: "全部",
    Clear: "清空",
    Yes: "是",
    No: "否",
    Template: "模板",
    AddEquipment: "添加设备",
    DownloadReport: "下载报告",
    MultiInput: "多点同步输入",
    AddBaseline: "新增基线",
    Estimate: "数据预测",
    Calculate: "计算",
    ViewDetail: "查看详情",
    CollapseDetail: "收起详情",
    Generate: "生成",
    Input: "编辑",
    Reconfigure: "自定义优化",
    Optimize: "优化",
    CurrentYear: "本年",
    LastYear: "去年",
    NextYear: "明年",
    Last12Months: "过去 12 个月",
    Next12Months: "未来 12 个月",
    selectClearAll: "选择 / 清除 全部",
    View: "查看"
  },

  label: {
    ProjectName: "项目名称",
    Multiple: "可多选",
    BuildVertical: "建筑类型",
    DataCollectionMont: "数据采集月份",
    CurrencyLabel: "货币",
    TemperatureUnit: "温度单位",
    Unit: "单位",
    Time: "时间",
    Hour: "小时",
    Hours: "小时",
    Day: "天",
    Days: "天",
    Month: "月",
    Months: "月",
    Year: "年",
    Years: "年",

    ChillerType: "冷水机组类型",
    PumpingConfiguration: "泵系统配置",
    Primary: "一次侧",

    RatedPower: "额定功率",
    RatedInputPower: "额定输入功率",
    RatedCoolingCapacity: "额定制冷量",
    Frequency: "频率",
    MaxHz: "最大频率",
    MinHz: "最小频率",
    RatedFrequency: "额定频率",
    MaxFrequency: "运行频率上限",
    MinFrequency: "运行频率下限",
    RatedHeatRejectionCapacity: "额定散热量",

    VFD: "变频",
    VariableFrequencyDrive: "变频驱动",

    AssetLabels: "资产标签",
    UnitNumber: "设备数量 (#)",
    PumpType: "泵类型",
    DateCommissioned: "投运日期",
    Degradation: "老化系数",
    Brand: "品牌",
    Model: "型号",
    Remarks: "备注",

    RatedInputPower_100: "额定输入功率",
    RatedInputPower_100_ct: "每座冷却塔额定输入功率",

    RatedCoolingCapacity_100: "额定制冷量",
    RatedHeatRejectionCapacity_100: "额定散热量",

    DesignCondenserWaterEnteringTemp: "设计冷却水进水温度",
    TotalCellPerCoolingTower: "冷却塔单元数",
    ActualCondenserWaterEnteringTemp: "实际冷却水进水温度",
    TotalCellPerDryCooler: "干冷器单元数",
    DryCoolerType: "干冷器类型",
    RatedCapacity: "额定容量",
    EnergyType: "输入能源",

    BaselineName: "基线名称",
    ApplicableMonths: "适用月份",

    DataTable: "数据表",
    ChartView: "曲线图",
    CoolingLoad: "冷负荷",
    Total: "合计",

    Observation: "观察记录",
    Photo: "照片",
    Maximum6: "最多 6 张",

    ChillerConfiguration: "冷机配置",
    BoilerConfiguration: "锅炉配置",
    CoolingSystemConfiguration: "冷却系统配置",

    MaxHeatingCapacity: "最冷月最大供热能力",
    EffectiveCapacity: "最冷月有效供热能力",
    BoilerEfficiency: "锅炉效率",
    hotWaterTemp: "热水供水目标温度",

    EnergyCarbonIntensity: "能源碳强度",
    FuelCalorificValue: "燃料热值 (CV)",

    ZeroHeatingOAT: "供热零负荷室外温度",
    MaxHeatingOAT: "供热满负荷室外温度",
    DesiredHotWaterTemp: "目标热水温度",
    BoilerUtilizationColdestTemp: "最冷工况锅炉利用率",
    ColdestWater: "最低进水温度",

    WaterDemandPerDay: "人均日用水量",
    UserNumber: "使用人数",
    liters: "升",

    ChillerModel: "冷机型号",
    RefChillerModel: "参考冷机型号",
    WeatherProfile: "气象曲线",
    EstimatePath: "估算路径",
    AvailableData: "可用数据",
    CondenserWaterTempProfile: "冷却水温度曲线",

    DesignCondenserSupplyTemp: "设计冷却水供水温度",
    DesignCondenserAirSupplyTemp: "设计冷凝器进风温度",
    DesignChilledWaterTemp: "设计冷冻水供水温度",
    OutDoorDryBulbTemp: "室外干球温度",
    ChilledWaterSupplyTemp: "冷冻水供水温度",
    TowerApproachTemp: "冷却塔逼近温差",
    ActualCondenserSupplyTemp: "实际冷却水供水温度",
    ActualCondenserAirSupplyTemp: "实际冷凝器进风温度",
    ActualChilledWaterSupplyTemp: "实际冷冻水供水温度",
    MinCondenserWaterSupplyTemp: "最小冷却水供水温度",
    DesignSourceWaterTemp: "设计热源水供水温度",
    DesignSourceAirTemp: "设计热源空气温度",
    DesignHotWaterSupplyTemp: "设计热水供水温度",

    ChillerRunningNumber: "当前运行冷机台数",
    CoolingCapacityRange: "制冷量范围",
    AllRightsReserved: "保留所有权利。",

    From: "从",
    To: "到",

    Cluster: "聚类",
    ClusterNum: "聚类数量",
    ClusterName: "聚类名称",
    WeekPeriod: "周周期",
    AssociationMethod: "关联方法",

    MaxCoolingLoadBaseline: "基线最大冷负荷",
    MaxCoolingLoad: "最大冷负荷",
    AssociatedChiller: "关联冷机",
    MaxRunningNumber: "最大运行台数",
    Chiller: "冷机",
    AssociatedHeatPump: "关联热泵",

    RetrofitPreferences: "改造偏好",

    CAPEX: "CAPEX（项目价格含安装）",
    OverallProjectPrice: "项目总价",
    USFXRate: "外汇汇率",

    Option: "选项",
    Solution: "方案",

    GeneralInfo: "基本信息",
    TechSpec: "技术规格",
    PerformanceConditions: "性能工况",
    EcatPerformanceInput: "e-CAT 性能输入",
    Capacity: "容量",
    CoolingCapacity: "制冷量",
    SerialNumber: "序列号",
    ElectricalLoad: "电负荷",

    Category: "类别",
    EfficiencyImprovement: "效率提升",
    CostSavingsPerYear: "年总成本节省",
    ROI: "投资回报率",
    PaybackPeriod: "折现回收期",
    SimplePayback: "简单投资回收期",

    Estimated: "估算",
    Actual: "实际",

    Like: "喜欢",
    Dislike: "不喜欢",

    OptionDetails: "选项详情",
    TotalEnergySavings: "年总节能量",
    RetrofitCost: "改造成本",
    ExpectedYears: "资产生命周期",
    NPV: "净现值",

    ProjectIntroduction: "项目说明",
    Assumptions: "假设",
    AssumptionsConsider: "分析假设",
    AssumptionsAnalysis: "分析假设",

    ChillerPlant: "冷站",
    Configuration: "配置",
    PeakBuildingLoad: "建筑峰值冷负荷",
    OAT: "室外空气温度 (OAT)",
    EnergyConservationMeasures: "节能措施（ECM）",

    DesignFlowRate: "设计流量",
    RatedDesignFlowRate: "额定设计流量",
    DesignPressureHead: "设计扬程",
    PressureHead: "扬程",
    VFDFitted: "已装 VFD",

    DesignConditions: "设计工况",
    ProjectSettings: "项目设置",

    Tariff: "费率",
    EnergyTariff: "能源费率",
    MonthlyTariff: "月度费率",
    OperatingPeriod: "运行时段",
    RunningMonths: "运行月份",

    Recommendation: "推荐",
    Benefit: "收益",

    MonthlyRunningDays: "{type}运行天数",
    BaselineMonth: "基线月份",
    EstimatedMonth: "估算月份",
    EstimatedPower: "估算功率",
    ElectricityCarbonIntensity: "电力碳强度",
    PlantEfficiency: "冷站效率",
    EfficienctyUnit: "效率单位",

    Type: "类型",
    SellingPricePrtUnit: "单机售价",
    ApplicableChiller: "适用冷机",
    NoOfFansCT: "冷却塔风机数量 / 塔",

    Load: "负荷",
    Power: "功率",
    InputPower: "输入功率",

    TotalEnergyImprovement: "总能效提升",
    EquipmentStatus: "设备状态",

    SetRecommended: "设为推荐",
    CancelRecommendation: "取消推荐",

    Optional: "可选",

    RetrofitCostConfiguration: "改造成本配置",
    PaybackPeriodSummaryNPV: "回收期与 NPV 汇总",

    EquipmentDetailsProposed: "拟议设备详情",
    GenerateECMReport: "生成 ECM 报告",

    PeakMaxCoolingLoad: "峰时最大冷负荷",
    OffPeakMaxCoolingLoad: "谷时最大冷负荷",

    ProposedCoolingCapacity: "拟议冷机制冷量",

    ChillerPlantTotal: "冷站合计",

    EnergySavingsPerYear: "年节能量",

    CapitalAssetRetrofitInvestmentCost: "固定资产改造投资成本",
    EstimatedProjectValue: "预计项目价值",
    ActualProjectValue: "实际项目价值",

    ProjectDetails: "项目详情",

    ElectricalDB: "配电柜",
    PlantControlSys: "冷站控制系统",

    QuickSelect: "快速选择",
    ClusterMonth: "聚类月份",

    MonthlyCoolingLoad: "月度冷负荷",
    MonthlyPower: "月度功率",

    Default: "默认",
    ReconfigureSolution: "优化方案",
    ReconfiguredSolution: "优化方案",

    SingleChilledWaterTemp: "单一冷冻水供水温度",
    ECatPerformanceData: "eCAT 性能数据",
    CopyInputECATPerformance: "复制 eCAT 性能数据输入",

    CopyFrom: "复制自",
    PasteInto: "粘贴到",

    PredictedUtilization: "预测利用率",
    UserConfirmedUtilization: "确认利用率",

    ProjectObjective: "项目目标",
    ChillerEfficiency: "冷机效率",
    ChillerPlantEfficiency: "冷站效率",
    HeatingEfficiency: "供热效率",
    HeatingPlantEfficiency: "供热系统效率",
    ChillerHeatingEfficiency: "冷机/供热效率",
    ChillerRetrofit: "冷机改造",
    ChillerPlantRetrofit: "冷站改造",
    HeatingElectricRetrofit: "锅炉改热泵改造",
    HeatPumpRetrofit: "热泵改造",
    IntegratedRetrofit: "冷/热一体化改造",

    ManualInput: "请手动输入",
    AutoSoon: "自动估算即将上线",

    AvailableDesignTemp: "可用设计温度",
    ChillerSelection: "冷机选择",
    NewChillerSeries: "新选冷机系列",
    ECATLibraryType: "E-CAT 库类型",
    PerformanceTable: "性能表",
    ChillerName: "冷机名称",
    StandardECAT: "标准 eCAT",
    EstimatedECAT: "估算 eCAT",
    CustomizedECAT: "自定义 eCAT",
    CustomCapacity: "自定义容量",

    OperatingDayType: "运行日类型",
    MonthlyOperatingDays: "月度运行天数",
    OperatingSiteChiller: "现场运行冷机",
    ProxyChillerModel: "参考冷机型号",
    ManufacturingRegion: "生产区域",
    CompressorType: "压缩机类型",
    BearingType: "轴承类型",
    VFDType: "变频器类型",
    AvailableProxyModels: "可用参考机型",
    NominalCapacity: "名义制冷量",
    PointsCalibration_4: "4点校准",
    PartLoadCalibration_note: "部分负荷校准仅支持工厂设计工况数据。",

    HourlyChillerOperation: "冷机逐时运行",
    OperatingChillerCount: "运行冷机数量",
    LoadRatio: "负荷率",
    CalculatedOperatingLoad: "计算运行负荷",

    NewChillerType: "新冷机类型",

    ProposedEfficiency: "提案效率",
    RetrofitConfiguration: "改造配置",
    ROI_NPVSummary: "ROI和NPV汇总",
    AssumptionOfferings: "假设与方案内容",

    ProposedRunningNumber: "提案运行设备数量",

    ProposedSummary: "提案摘要",
    BaselineEfficiency: "基线效率",
    AnnualizedAverageROI: "基于 NPV 的年化平均 ROI",

    SelectProposedScenarios: "选择拟议方案",
    BaselineHourlyCoolingLoad: "基线逐时冷负荷",

    ProxyChillerFilter: "参考冷机筛选",
    ChillerEfficiency_100: "冷机满负荷效率",
    DegradedEfficiency_100: "满负荷退化效率",

    CommercialInput: "商务输入",

    SiteSettings: "现场设置",
    ExistingBoilerSystem: "现有锅炉系统",
    HeatingApplication: "供热应用",

    PerformanceModel: "性能模型",
    HeatingCapacityPerUnit: "每台额定供热能力",
    BaselineSetup: "基线设置",
    OperatingMonths: "运行月份",
    OperatingBoiler: "运行锅炉",
    BoilerNumAtColdest: "最冷温度下运行锅炉数量",
    singlePriceNote: "用于估算项目 CAPEX(含安装费用)。",

    BoilerDetails: "锅炉详情",
    HeatPumpCfg: "热泵配置",
    HeatPumpSourceType: "热泵热源类型",
    HotWaterSupplyTemp: "热水供水温度",
    ActualHWSTemp: "实际热水供水温度",
    SingleHWSTemp: "单一热水供水温度",
    WaterSourceTemp: "水源温度",
    GroundLoop: "地源回路",
    HeatingCapacity: "供热能力",
    RatedHeatingCapacity: "额定供热能力",
    HeatPumpSelection: "热泵选择",
    HeatPumpName: "热泵名称",
    HeatPumpModel: "热泵型号",
    ModelNumber: "设备编号",
    AirSourceTemp: "空气源温度",
    DesignAirSourceTemp: "设计空气源温度",
    DesignEWSTemp: "设计蒸发器供水温度",
    RatedCOP_100: "额定 COP（100%）",

    ProposedHeatPumpCOP: "拟议热泵 COP",
    MaxHeatingLoad: "最大供热负荷",
    ProposedHeatPumpCapacity: "拟议热泵每台容量",
    CostAssumptionInputs: "成本与假设输入",
    ExistingAnnualCost: "现有年成本",
    ProposedAnnualCost: "拟议年成本",
    Escalation: "成本递增"
  },

  option: {
    New: "新增",
    Existing: "现有",
    Remove: "移除",

    LARGE_OFFICE: "大型办公",
    MEDIUM_OFFICE: "中型办公",
    SMALL_OFFICE: "小型办公",
    RESTAURANT: "餐饮",
    HOSPITAL: "医院",
    HOTEL: "酒店",
    MALL: "商场",
    SCHOOL: "学校",
    EDUCATIONAL_INSTITUTIONS: "教育机构",
    RESIDENTIAL: "住宅",
    OTHERS: "其他",

    Month: "月",
    Jan: "1月",
    Feb: "2月",
    Mar: "3月",
    Apr: "4月",
    May: "5月",
    Jun: "6月",
    Jul: "7月",
    Aug: "8月",
    Sep: "9月",
    Oct: "10月",
    Nov: "11月",
    Dec: "12月",

    plant: "冷站",
    chiller: "冷机",
    pump: "泵",
    coolingTower: "冷却塔",
    piping: "管道",
    dryCooler: "干式冷却器",
    controlSys: "控制系统",
    boiler: "锅炉",
    heatPump: "热泵",
    other: "其他",

    WaterCooled: "水冷",
    AirCooled: "风冷",
    WaterCooled_AirCooled: "水冷 & 风冷",

    chwp: "冷冻水泵",
    chwpPrimary: "冷冻水泵 - 一次泵",
    chwpSecondary: "冷冻水泵 - 二次泵",
    PrimaryPump: "一次泵",
    SecondaryPump: "二次泵",
    cwp: "冷却水泵",
    CondenserWater: "冷却水",
    ChilledWaterPrimary: "一次冷冻水系统",
    ChilledWaterPrimarySecondary: "一次 - 二次冷冻水系统",
    CondenserWaterSys: "冷却水系统",
    CommonHeader: "公共集管",
    Dedicated_1_1: "独立 1-1",

    wcCentri: "水冷-离心",
    wcScrew: "水冷-螺杆",
    wcRecip: "水冷-往复",
    wcScroll: "水冷-涡旋",
    acScrew: "风冷-螺杆",
    acScroll: "风冷-涡旋",
    acRecip: "风冷-往复",

    Centrifugal: "离心",
    Screw: "螺杆",
    Scroll: "涡旋",
    Reciprocating: "往复",
    Rotary: "转子式",

    Degradation_25: "0.25% / 年",
    Degradation_50: "0.50% / 年",
    Degradation_75: "0.75% / 年",
    Degradation_100: "1.00% / 年",

    GoodCondition: "状态良好",
    AverageCondition: "状态一般",
    BelowAverageCondition: "状态偏差",
    BadCondition: "状态较差",

    SpaceCooling: "舒适性制冷",
    SpaceHeating: "供热",
    DomesticHotWater: "生活热水",
    SHandDHW: "供热 & 生活热水",

    GasFuel: "燃气",
    LiquidFuel: "燃油",
    ElectricalEnergy: "电能",

    DryBulbTemp: "平均干球温度",
    WetBulbTemp: "平均湿球温度",
    WaterTemp: "水温",

    MaxDryBulbTemp: "平均最高干球温度",
    MinDryBulbTemp: "平均最低干球温度",
    AvgDryBulbTemp: "平均干球温度",
    MaxWetBulbTemp: "平均最高湿球温度",
    MinWetBulbTemp: "平均最低湿球温度",
    AvgWetBulbTemp: "平均湿球温度",

    PeakWaterTemp: "峰时水温",
    OffPeakWaterTemp: "谷时水温",
    AvgTemp: "平均温度",

    ColdWaterTemp: "进水温度",

    CondenserWaterSupplyTemp: "冷却水供水温度",
    MeanCondenserWaterSupplyTemp: "冷却水平均供水温度",
    MeanMaxCWSTemp: "冷却水平均最高供水温度",
    MeanAvgCWSTemp: "冷却水平均供水温度",

    CondenserAirSupplyTemp: "冷凝器进风温度",
    MeanCondenserAirSupplyTemp: "冷凝器平均进风温度",
    MeanMaxCASTemp: "冷凝器平均最高进风温度",
    MeanAvgCASTemp: "冷凝器平均进风温度",

    PathA: "基于冷负荷",
    PathB: "基于能耗",
    Method1: "1 个月小时曲线",
    Method3: "12 个月小时曲线",

    HeatingPathA: "仅锅炉负荷路径",
    HeatingPathB: "锅炉负荷 + 能耗数据路径",

    Off: "关闭",
    Peak: "峰时",
    OffPeak: "谷时",
    AllPeak: "全时段",
    PeakPeriod: "峰时段",
    OffPeakPeriod: "谷时段",
    WeekdayPeak: "工作日峰时",
    WeekdayOffPeak: "工作日谷时",
    WeekendPeak: "周末峰时",
    WeekendOffPeak: "周末谷时",

    AllCity: "全部城市",
    MegaCity: "特大城市",
    NonMegaCity: "非特大城市",

    Win: "已成交",
    PipeLine: "跟进中",
    TotalPipeline: "在跟项目总数",
    ActualOrder: "实际订单",
    ExpectedOrder: "预计订单",

    All: "全部",
    Values: "数值",
    Projects: "项目",
    Count: "项目数量",
    WinProbability: "赢得概率",

    SingleCluster: "单一聚类",
    MultipleCLuster: "多聚类",

    HighestEfficiencyImprovement: "最高效率提升",
    LowestInvestment: "最低投资",
    ShortestPaybackPeriod: "最短回收期",

    Max: "最大",
    Min: "最小",
    Avg: "平均",

    StepMonthlyCoolingLoad: "月度冷负荷",
    StepEstimateCoolingLoad: "估算冷负荷",
    StepEstimatePower: "估算冷机功率",
    StepEstimatePowerLoad: "估算冷机功率",
    EstimateChillerCount: "估算冷机数量",

    OperatingCalendar: "运行日历",
    OperatingHours: "运行小时数",
    OperatingLoad: "运行负荷",
    ReferChiller: "参考冷机",
    MonthlyChillerCount: "月度冷机数量",

    RunningHours: "运行小时",
    EnergyConsumption: "能耗",
    ChillerEnergyConsumption: "冷机能耗",

    AuxiliaryPower: "辅助设备功率",
    PlantEquipment: "冷站设备",
    ChillerPower: "冷机功率",
    CHWPPower: "冷冻水泵功率",
    CWPPower: "冷却水泵功率",
    CTPower: "冷却塔功率",

    WeightedAvgEfficiency: "加权平均效率",
    WeightedAvgCoolingLoad: "加权平均冷负荷",
    WeightAvgPower: "加权平均功率",
    RunningHrsPerDay: "日运行小时",
    ActualWeightedAveragePower: "实际加权平均功率",

    AnnualCost: "年成本",
    AnnualEscalation: "年成本增幅",
    IncentiveRebate: "激励/返利",

    ProposeConfig: "拟议配置",

    Weekday: "工作日",
    Weekend: "周末",
    WholeWeek: "全周",

    Automatic: "自动方案",
    Manual: "自定义",
    Reconfigured: "优化方案",
    AlgorithmSelectsConfig: "算法自动配置",
    UserSelectsConfig: "用户自定义",

    ManualCluster: "手动聚类",
    DigitalECAT: "数字 eCAT",

    BoilerUtilization: "锅炉利用率",
    HeatingLoad: "供热负荷",
    MonthlyHeatingLoad: "月度供热负荷",
    EffectiveMonthly: "有效月供热能量",
    EnergyCharges: "能源费用",
    CO2Emissions: "CO₂ 排放",
    GasFuelConsumption: "燃气消耗量",
    LiquidFuelConsumption: "燃油消耗量",
    ElectricalEnergyConsumption: "电能消耗",
    GasFuelCharges: "燃气费用",
    LiquidFuelCharges: "燃油费用",
    ElectricalEnergyCharges: "电费",

    Standard: "标准",
    Ceramic: "陶瓷",
    Magnetic: "磁悬浮",
    VFD: "变频",
    NonVFD: "定频",
    ClusterMonths: "聚类月份",

    Chiller: "冷机",
    HeatPump: "热泵",
    WaterSource: "水源式",
    AirSource: "空气源式",

    ConstantEfficiency: "恒定效率",
    UserDefinedCurve: "自定义曲线",
    BoilerOperation: "锅炉运行",
    MonthlyEnergyConsumption: "月度能源消耗",
    AvgHeatingLoad: "加权平均供热负荷",
    MonthlyBoilerCount: "月度锅炉台数",
    BoilerEnergyConsumption: "锅炉能耗",
    EstimateBoilerCount: "估算锅炉数量",
    EstimateHeatingLoad: "估算供热负荷",
    EstimateEnergyConsumption: "估算锅炉能耗",

    ECatLib: "e-CAT 库",
    OwnLib: "自定义库"
  },

  msg: {
    imageOnly: "仅允许上传图片文件",
    comingSoon: "敬请期待",
    Success: "操作成功",
    FailedRetry: "操作失败，请重试",
    DeleteEquip: "删除设备",
    DeleteWarning: "确认删除：",
    DeleteBaseline: "删除基线",
    Warning: "提示",
    UnsavedWarning: "直接退出当前页，未保存的数据将丢失。",
    SaveBeforeProceeding: "继续前是否保存更改？",
    NoOptionsSelected: "未选择任何选项",
    AlreadyExists: "已存在",
    Saving: "保存中...",
    Generating: "生成中...",
    Loading: "加载中...",
    DeletingFiles: "删除文件中...",
    CompressingFiles: "压缩文件中...",
    UnsupportedImageTypeTitle: "已跳过不支持的文件",
    UnsupportedImageTypesDiscarded: "被跳过的文件类型",
    UploadingFiles: "上传文件中...",
    NetworkError: "网络异常，操作失败",
    NetworkLimit: "网络异常，功能受限",
    Over24HoursTips: "总时长超过 24 小时",
    Over24HoursToast: "峰/谷时段总时长不能超过 24 小时",
    CityChanged: "城市已从 {curtCity} 切换为 {newCity}。",
    OverrideWeatherData: "<br>是否使用新选择城市的 OAT（室外温度）覆盖现有气象曲线数据？",
    ProjectNameIsEmpty: "项目名称不能为空",
    CityIsEmpty: "城市不能为空",
    SelectReferModel: "请选择参考机型",
    InputDataIntoReferenceChiller: "将以上数据填入参考冷机",
    PeriodCanNotAllOff: "运行时段不能全部为“关闭”",
    CanNotBlank: "不能为空",
    CanNotBlankZero: "不能为空或为 0",
    CanNotAllBlank: "不能全部为空",
    CanNotAllBlankZero: "不能全部为空或全部为 0",
    NetworkTimeout: "网络超时，请重试",
    RequestError: "请求错误",
    LoginExpired: "登录已过期",
    AccessDenied: "拒绝访问",
    ResourceNotExist: "请求的资源不存在",
    ServerError: "服务错误",
    GatewayError: "网关错误",
    ServiceUnavailable: "服务不可用",
    UserNotExist: "用户不存在",
    WrongPassword: "密码错误",
    NotActivate: "账号未激活",
    DeleteCluster: "删除聚类",
    Estimating: "估算中...",
    Analyzing: "分析中...",
    Calculating: "计算中...",
    UnsavedAfterEstimate: "上次估算后输入但未保存的数据将在离开页面后丢失。",
    DiscountRateTips: "折现率用于反映预期投资回报；若未提供，则默认采用通胀率。",
    CalculateROINotice: "请先点击“1. 编辑”补全改造成本，然后再点击“计算 ROI”。",
    ConfirmFxRate: "请确认美元汇率",
    SetRecommended: "将 {name} 设为推荐",
    SelectCardPasteInto: "请选择要粘贴到的卡片",
    Copied: "已复制到剪贴板",
    Pasted: "已粘贴",
    OverwriteOption: "重新生成将覆盖所有现有解决方案数据，并删除已生成的报告。",
    OverwriteOptionAll: "您已配置优化方案。<br/>重新生成将覆盖所有现有解决方案数据，并删除已生成的报告。",
    RefreshRequired: "需要刷新",

    ReAnalysisPre: "要生成或更新基线预览，请先在月度基线中刷新制冷负荷和功率分析，然后手动刷新基线预览。",
    ReAnalysisHeating: "要生成或更新基线预览，请先在月度基线中刷新供热负荷和电力分析，然后手动刷新基线预览。",

    PleaseSelectObjective: "请选择项目目标",
    HeatingOnlySupportsPre: "供热电气化改造模块目前仅支持基线阶段",
    CompleteBaselineConfigFirst: "请先完成改造前阶段的基线配置。",
    CompleteBaselineAnalysisFirst: "请先完成改造前阶段的基线分析。",

    AcceptOneUtilization: "接受预测利用率作为确认利用率？",
    AcceptAllUtilization: "接受全部预测利用率作为确认利用率？",
    NoReportGenerate: "尚无报告，请进入项目进行生成。",

    DependencyHint: "关联提示：",
    DryBulbDependencyCooling: "干球温度用于估算制冷负荷曲线。",
    WeatherDependencyCooling: "对于水冷冷机，冷却水供水温度用于估算冷机耗电量；对于风冷冷机，则采用干球温度进行估算。",

    DryBulbDependencyHeating: "干球温度用于估算供热负荷曲线，而进水冷水温度用于估算生活热水负荷曲线。",
    WeatherDependencyHeating: "上方显示的气象参数取决于所选择的供热应用类型。",

    CalibrationTitle: "四点标定数据不完整",
    CalibrationNote: "参考冷机的四点标定数据不完整。请输入全部四个负荷点（25%、50%、75% 和 100%）的数值，或者关闭四点标定后继续。",
    CalibrationBack: "返回参考冷机",

    SelectReportingFocus: "选择客户报告重点",
    ROILedSummary: "ROI导向总结",
    EfficiencyLedSummary: "效率提升导向总结",
    ROILedNote: "当投资、节余和回报结果足以证明项目的合理性时使用。",
    EfficiencyLedNote: "当效率提升为主要理由时使用，无论回报周期是否有吸引力。",
    ROILedNote_C: "当项目已具备投资成本、节能收益及投资回收期等财务数据时使用。",
    EfficiencyLedNote_C: "当决策主要基于能效提升，且ROI数据无法获取或参考意义有限时使用。",

    ImgIgnoredWhenOffline: "设备离线，图片操作将忽略"
  },

  placeholder: {
    PleaseInput: "请输入",
    SearchHere: "搜索",
    PleaseSelect: "请选择",
    SearchFilter: "搜索与筛选",
    NotAvailable: "不可用",
    NoDataExist: "暂无数据",
    NoDataAvailable: "暂无可用数据",
    NoChillerExist: "暂无冷机数据",
    NoBaselineExist: "暂无基线数据",
    ClusterAutomaticallyMatches: "自动匹配所有运行时段",
    NoClusterExist: "暂无聚类月份，请先设置聚类月份",
    SelectTempCluster: "请选择聚类温度",
    PleaseSelectInputFormat: "请选择或输入，格式：",
    SearchFormat: "搜索，格式：",
    DigitalECatNotify: "数字 eCAT 数据正在集成中，请暂时使用手动聚类",

    AssumptionsPlaceholder: "请概述分析所依据的假设条件。具体说明考虑的天气状况、设备月度运行情况以及访谈中分享的客户数据。您也可以使用模板按钮获取标准描述。",

    AssumptionsTemp:
      "本次分析基于【冷水机组能耗数据 / 冷量负荷数据】开展。上述数据由对现场运行人员的访谈与运营信息整理后估算得到，并作为 iECM 基线评估的输入之一。基于该数据，我们将既有【填写冷水机组型号】在各月份的部分负荷（Part-load）性能与对应月份的当地历史气象数据进行关联，从而估算该机组在目标周期内的月度运行表现与能耗水平。\n\n\
（可选：当冷水机能耗仅作为全楼能耗占比输入时使用）\n\
冷站能耗占比假设：\n\
假设冷水机房（Chiller Plant）的能耗约占建筑总能耗的【填写占比，例如 45%】。\n\n\
经客户团队确认，以下运行参数用于本次估算：\n\
冷水机组运行计划（Chiller Operating Schedule）：\n\
【数量】台冷水机组在【月份】至【月份】期间运行；\n\
【数量】台冷水机组在【月份】至【月份】期间运行；",

    ObservationNote: "仅保留适用的括号选项，并在保存前核实所有现场信息。",
    Observation_chiller: "现有冷水机组存在老化和效率下降迹象。现场记录显示设备有[频繁报警／能耗偏高／运行不稳定／维护需求增加]等问题，尤其是在[部分负荷／峰值负荷]工况下。",

    Recommendation_chiller: "开展详细性能测试，并检查运行设定值、制冷剂状态、换热表面和控制系统。根据测试结果优化运行，或更换为高效变频冷水机组。",

    Benefit_chiller: "预期可降低冷水机组能耗，提高部分负荷效率，减少非计划停机和维护成本，并使冷冻水供应更加稳定。采用高效机组还可减少碳排放，并提高冷站的长期运行可靠性。",

    Observation_pump: "现有[冷冻水泵／冷却水泵]采用[定速运行／低效运行点]。部分负荷时流量可能高于实际需求，现场发现[噪声／振动／泄漏／压力不稳定]。",

    Recommendation_pump: "核查水泵负荷、流量、扬程、阀门位置及系统水力平衡，并重新调试水泵和控制逻辑。条件允许时，安装或启用变频器，根据压差或冷站实际需求调节水泵转速。",

    Benefit_pump: "该措施可降低水泵能耗，减少过量流量和节流损失，改善系统温差及水力稳定性，并降低机械磨损。按需运行还可减少维护需求，提高冷站整体效率。",

    Observation_coolingTower: "冷却塔存在[逼近温差偏高／填料脏堵／布水不均／风机控制不佳／明显结垢]。冷却水温度无法持续保持在高效运行水平。",

    Recommendation_coolingTower: "检查并清洁填料、水盘、喷嘴、过滤器和换热表面；核查水处理、气流及风机运行。优化冷却塔台数控制，并采用变频调节以维持所需冷却水温度。",

    Benefit_coolingTower: "改善冷却塔性能可在安全运行范围内降低冷却水温度，减少冷水机组压升和能耗，稳定冷站运行，并降低结垢或腐蚀风险。优化风机控制还可降低冷却塔能耗并延长设备寿命。",

    Observation_controlSys: "现有控制系统主要提供基础监控，未能充分优化冷水机组、水泵和冷却塔的联动顺序。设定值及设备台数控制为[固定／手动调整／未随负荷协调]。",

    Recommendation_controlSys: "升级或重新调试冷站控制系统，增加按需排序、设定值重置、设备台数控制、报警管理和性能监测。校准关键的温度、压力、流量和功率传感器。",

    Benefit_controlSys: "通过将冷水机组、水泵和冷却塔作为整体协调控制，可提高系统综合效率，减少不必要的运行时间，稳定温度和流量，提高故障可见性，并支持持续的性能跟踪和能源优化。",

    Observation_dryCooler: "干式冷却器存在[盘管脏堵／气流受阻／翅片损坏／出口液温偏高／风机控制不佳]。风机采用[定速／不稳定]运行，在[部分负荷／峰值负荷]下散热能力不足。",

    Recommendation_dryCooler: "检查并清洁换热盘管，修复损坏翅片并清除气流障碍。核查液体流量、风机转向、传感器及控制。根据出口液温和系统需求优化风机台数或采用变频控制。",

    Benefit_dryCooler:
      "改善干式冷却器性能可降低液体温度，提高系统散热能力，并减少风机和冷水机组能耗。优化风机控制可减少不必要的运行时间和噪声；定期维护盘管有助于保持容量、提高运行稳定性并延长设备寿命。",

    Observation_boiler: "现有锅炉提供[采暖/生活热水]。锅炉采用[燃料类型]运行，存在[高燃料消耗/频繁启停/供水温度过高/燃烧效率低/泄漏]等问题。现场监控有限，未观察到基于负荷的优化。",
    Recommendation_boiler: "评估供热负荷、供水温度、运行计划及末端设备需求。评估热泵适用性，并确定锅炉是否应保留用于峰值负荷或备用运行。",
    Benefit_boiler:
      "热泵的引入可在维持所需供热性能的同时，降低燃料消耗、碳排放及运行成本。合理的负荷匹配可提高季节能效，并可能减少对化石燃料燃烧的依赖。仅在峰值或备用工况下保留现有锅炉，可在支持脱碳目标的同时，将改造风险降至最低。"
  },

  param: {
    hr: "时间",
    period: "时段",
    chCount: "运行冷机台数",
    maxLoad: "最大额定负荷",
    percent: "负荷百分比",
    capacity: "运行总负荷",
    consumption: "能耗",
    existing: "现有",
    proposed: "拟议",
    assumptions: "假设",
    energy: "能源",
    maintenance: "维护",
    repair: "维修",
    other: "其他",
    discountRate: "折现率"
  },

  wizard: {
    navbar: {
      Wizard: "向导",
      MinimumInput: "快速设置",
      GenerateDefaults: "生成初始默认值",
      ReviewAssumptions: "检查假设",
      RunQuickCalculation: "运行快速计算",
      ProposedSolution: "评估结果"
    },
    label: {
      ActualConditions: "实际工况",
      MonthlyAverageTariff: "月平均电价",
      YearlyEnergyBill: "年度能源账单",
      ReviewSection: "审核部分",
      CoolingApplication: "制冷应用类型",
      TemperatureSensitivityFactor: "温度敏感系数"
    },
    option: {
      PROCESS_COOLING: "工艺制冷",
      DATA_CENTER: "数据中心",
      ComfortCooling: "舒适性制冷",
      MixedUse: "混合用途",
      ProcessDataCenter: "工艺制冷 / 数据中心",
      Custom: "自定义"
    },
    msg: {
      GeneratingDefaults: "正在生成默认值...",
      RunningQuickCalculation: "正在运行快速计算...",
      DataOverwriteWarning: "数据覆盖警告",
      PendingResultChangesWarning: "您已修改审核页面上的内容，请先生成新的结果再继续。",
      RegenerateDefaultsWarning: "重新生成默认值将永久覆盖审核页面上的当前图表数据。是否继续？",
      PeriodCanNotAllOffEveryBaseline: "每个基准的时段都不能全部设为“关闭”。"
    }
  }
}



// WEBPACK FOOTER //
// ./src/locale/index/zh.js